var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$route.meta.showHeader ? _c("Header") : _vm._e(),
      _c("router-view"),
      _vm.$route.meta.showFooter ? _c("Footer") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }